import { cn } from "@hulahoop/ui";

export function QuotaCapacityRow({
  color,
  label,
  value,
  alert,
  indented,
}: {
  color?: string;
  label: string;
  value: string;
  alert?: boolean;
  indented?: boolean;
}) {
  return (
    <div
      className={cn(
        "flex items-center justify-between text-xs",
        indented && "pl-4 text-muted-foreground",
      )}
    >
      <span className="flex items-center gap-1.5">
        {color && <span className={cn("size-2.5 rounded-sm", color)} />}
        <span className={cn(alert && "text-destructive")}>{label}</span>
      </span>
      <span className={cn("tabular-nums", !indented && "font-medium", alert && "text-destructive")}>
        {value}
      </span>
    </div>
  );
}
